import React, { useContext } from 'react'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { Checkbox, HStack, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import cx from 'classnames'
import { EBreakPoint } from 'enums/theme'
import useBreakPoint from 'hooks/useBreakPoint'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { Controller, useFormContext } from 'react-hook-form'
import FormInput from 'components/FormInput'
import { getValidArray } from 'utils/common'
import FormPhoneInput from '../../../SideBar/components/FormPhoneInput'
import { ApplicationContext } from '../../applicationForm.context'
import { DESKTOP_CONTAINER_WIDTH } from '../../constant'
import styles from './doYouQualify.module.scss'

interface IDoYouQualifyProps {
  hasPhoneNumberField?: boolean
}

const DoYouQualify = (props: IDoYouQualifyProps) => {
  const { hasPhoneNumberField } = props
  const { cmsPolicyStore } = useStores()
  const { sharedHousePolicies, entireHousePolicies } = cmsPolicyStore
  const {
    control,
    formState: { errors }
  } = useFormContext()
  const isNotDesktop: boolean = useBreakPoint(EBreakPoint.BASE, EBreakPoint.LG)
  const { isEntireHouse } = useContext(ApplicationContext)
  const requirementList: string[] = isEntireHouse ? entireHousePolicies : sharedHousePolicies

  return (
    <VStack
      spacing={{ base: 6, lg: 8 }}
      paddingX={4}
      marginTop={{ base: 0, lg: 32 }}
      paddingTop={{ base: 6, lg: 8 }}
      paddingBottom={{ base: 6, lg: 4 }}
      maxWidth={{ base: 'full', lg: DESKTOP_CONTAINER_WIDTH }}
      marginX="auto"
      marginBottom={{ base: 16, md: 28, lg: 0 }}
      width="full"
    >
      <HStack spacing={{ base: 6, lg: 8 }} width="full">
        <FormInput
          height={isNotDesktop ? '48px' : '40px'}
          width={isNotDesktop ? 'calc((100% - 24px) / 2)' : 'full'}
          className={styles.inputContainer}
          name="firstName"
          label="Your Name"
          placeholder="First name"
          autoComplete="off"
        />
        <FormInput
          height={isNotDesktop ? '48px' : '40px'}
          width={isNotDesktop ? 'calc((100% - 24px) / 2)' : 'full'}
          className={styles.inputContainer}
          name="lastName"
          label="Last name"
          placeholder="Last name"
          hideLabel
          autoComplete="off"
        />
      </HStack>
      <FormInput
        height={isNotDesktop ? '48px' : '40px'}
        name="email"
        label="Your Email Address "
        placeholder="Enter Your Email"
        type="email"
        autoComplete="off"
        className={cx({ [styles.formEmail]: errors?.firstName?.message ?? errors?.lastName?.message })}
      />
      {hasPhoneNumberField && (
        <FormInput name="phoneNumber" label="Your Phone Number" hideErrorMessage>
          <FormPhoneInput />
        </FormInput>
      )}
      <FormInput name="confirm" label="Let’s make sure you qualify:">
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap={2} marginTop={4}>
          {getValidArray(requirementList).map((requirement: string, index: number) => {
            if (!requirement) return <></>
            return (
              <HStack spacing={2.5} key={index} alignItems="flex-start">
                <CheckCircleIcon color="teal" marginTop="3px" />
                <Text fontSize="sm" color="gray.700" fontWeight={400} lineHeight={5} textAlign="left">
                  {requirement}
                </Text>
              </HStack>
            )
          })}
        </SimpleGrid>
        <Controller
          name="confirm"
          control={control}
          rules={{ required: 'You must meet the requirements to continue.' }}
          render={({ field: { onChange, value, ref } }) => (
            <Checkbox
              id="confirm"
              textAlign="left"
              colorScheme="teal"
              color="gray.700"
              marginTop={4}
              onChange={onChange}
              ref={ref}
              isChecked={value}
              alignItems="flex-start"
              className={styles.checkbox}
            >
              I understand and meet the above requirements
            </Checkbox>
          )}
        />
      </FormInput>
    </VStack>
  )
}

export default observer(DoYouQualify)
